var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context"},[_c(_vm.componentId,{ref:_vm.componentId,tag:"component",on:{"changeTopTab":_vm.switchModule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }